// NEWS ACTION TYPES
// Fetch news stories
export const FETCH_NEWS_TRIGGER = 'FETCH_NEWS_TRIGGER'
export const FETCH_NEWS_SUCCESS = 'FETCH_NEWS_SUCCESS'
export const FETCH_NEWS_ERROR = 'FETCH_NEWS_ERROR'

// Fetch single story
export const FETCH_SINGLE_NEWS_TRIGGER = 'FETCH_SINGLE_NEWS_TRIGGER'
export const FETCH_SINGLE_NEWS_SUCCESS = 'FETCH_SINGLE_NEWS_SUCCESS'
export const FETCH_SINGLE_NEWS_ERROR = 'FETCH_SINGLE_NEWS_ERROR'
export const CLEAR_SINGLE_NEWS = 'CLEAR_SINGLE_NEWS'

// Create news story
export const CREATE_NEWS_TRIGGER = 'CREATE_NEWS_TRIGGER'
export const CREATE_NEWS_SUCCESS = 'CREATE_NEWS_SUCCESS'
export const CREATE_NEWS_ERROR = 'CREATE_NEWS_ERROR'

// Update news story
export const UPDATE_NEWS_TRIGGER = 'UPDATE_NEWS_TRIGGER'
export const UPDATE_NEWS_SUCCESS = 'UPDATE_NEWS_SUCCESS'
export const UPDATE_NEWS_ERROR = 'UPDATE_NEWS_ERROR'

// Delete news story
export const DELETE_NEWS_TRIGGER = 'DELETE_NEWS_TRIGGER'
export const DELETE_NEWS_SUCCESS = 'DELETE_NEWS_SUCCESS'
export const DELETE_NEWS_ERROR = 'DELETE_NEWS_ERROR'

// CLIENT ACTION TYPES
// Fetch client profiles
export const FETCH_CLIENT_TRIGGER = 'FETCH_CLIENT_TRIGGER'
export const FETCH_CLIENT_SUCCESS = 'FETCH_CLIENT_SUCCESS'
export const FETCH_CLIENT_ERROR = 'FETCH_CLIENT_ERROR'

// Fetch single client profile by ID
export const FETCH_SINGLE_CLIENT_TRIGGER = 'FETCH_SINGLE_CLIENT_TRIGGER'
export const FETCH_SINGLE_CLIENT_SUCCESS = 'FETCH_SINGLE_CLIENT_SUCCESS'
export const FETCH_SINGLE_CLIENT_ERROR = 'FETCH_SINGLE_CLIENT_ERROR'
export const CLEAR_SINGLE_CLIENT = 'CLEAR_SINGLE_CLIENT'

// Fetch all news for a single client
export const FETCH_CLIENT_NEWS_TRIGGER = 'FETCH_CLIENT_NEWS_TRIGGER'
export const FETCH_CLIENT_NEWS_SUCCESS = 'FETCH_CLIENT_NEWS_SUCCESS'
export const FETCH_CLIENT_NEWS_ERROR = 'FETCH_CLIENT_NEWS_ERROR'
export const CLEAR_CLIENT_NEWS = 'CLEAR_CLIENT_NEWS'

// Create client profile
export const CREATE_CLIENT_TRIGGER = 'CREATE_CLIENT_TRIGGER'
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS'
export const CREATE_CLIENT_ERROR = 'CREATE_CLIENT_ERROR'

// Update client profile
export const UPDATE_CLIENT_TRIGGER = 'UPDATE_CLIENT_TRIGGER'
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS'
export const UPDATE_CLIENT_ERROR = 'UPDATE_CLIENT_ERROR'

// Delete client profile
export const DELETE_CLIENT_TRIGGER = 'DELETE_CLIENT_TRIGGER'
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS'
export const DELETE_CLIENT_ERROR = 'DELETE_CLIENT_ERROR'

// PAGE ACTION TYPES
// Fetch page information
export const FETCH_INFO_TRIGGER = 'FETCH_INFO_TRIGGER'
export const FETCH_INFO_SUCCESS = 'FETCH_INFO_SUCCESS'
export const FETCH_INFO_ERROR = 'FETCH_INFO_ERROR'

// Update page information
export const UPDATE_INFO_TRIGGER = 'UPDATE_INFO_TRIGGER'
export const UPDATE_INFO_SUCCESS = 'UPDATE_INFO_SUCCESS'
export const UPDATE_INFO_ERROR = 'UPDATE_INFO_ERROR'

// FILE ACTION TYPES
// Upload image
export const UPLOAD_IMAGE_TRIGGER = 'UPLOAD_IMAGE_TRIGGER'
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS'
export const UPLOAD_IMAGE_ERROR = 'UPLOAD_IMAGE_ERROR'

// Upload file
export const UPLOAD_FILE_TRIGGER = 'UPLOAD_FILE_TRIGGER'
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS'
export const UPLOAD_FILE_ERROR = 'UPLOAD_FILE_ERROR'

// Unload file
export const UNLOAD_FILE = 'UNLOAD_FILE'

// TWITTER ACTION TYPES
// Post to Twitter
export const POST_TWEET_TRIGGER = 'POST_TWEET_TRIGGER'
export const POST_TWEET_SUCCESS = 'POST_TWEET_SUCCESS'
export const POST_TWEET_ERROR = 'POST_TWEET_ERROR'



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js